/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { useEffect, useMemo, useState } from 'react';
import { TIME_SELECT_DATA } from '@/shared/const';
import { getTimeOptions } from '../../utils/getTimeOptions';
import { getWeekendsDates, isToday, isTodayAndAfter4pm } from '../../utils/auxiliaryFuncitions';

type Props = {
    getValues: (prop: string) => string;
    setValue: Function;
    watch: (prop: string) => string;
};

export const useTimeSelectData = ({ getValues, watch, setValue }: Props) => {
    const [timeSelectData, setTimeSelectData] = useState(TIME_SELECT_DATA);

    useEffect(() => {
        if (isToday(watch('feedbackDate'))) {
            const options = getTimeOptions();

            setTimeSelectData(options);

            const currentSelectedTime = getValues('feedbackTime');

            if (!currentSelectedTime) {
                return;
            }

            options.forEach((el: { disabled: boolean; value: string }) => {
                if (el.value === currentSelectedTime && el.disabled) {
                    setValue('feedbackTime', '');
                }
            });
        } else {
            setTimeSelectData(TIME_SELECT_DATA);
        }
    }, [watch('feedbackDate')]);

    const disabledDays = useMemo(() => {
        const dates = getWeekendsDates().map((el) => {
            return { date: el };
        });

        if (isTodayAndAfter4pm()) {
            dates.push({ date: new Date() });
        }

        return dates;
    }, [timeSelectData]);

    return { disabledDays, timeSelectData };
};
